<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
    <div>
        <div class="position-relative w-100 overflow-hidden">
            <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
            <!-- Placeholder Hero Image -->
            <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/nJZkLsPpZmSAvwVRc9ZgOfkCdVvmbnGXWd4a0ILS.jpg"
                alt="Digital E-Library Hero" class="img-fluid w-100" />
            <!-- <div
                class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center w-25 text-start px-3 px-md-5">
                <h1 class="headingBL title mb-3 text-white">
                    Digital <br />E-Library
                </h1>
            </div> -->
        </div>
    </div>
</div>

<!-- Key Features Section -->
<section class="icon-features-section">
    <div class="container mb-5">
        <!-- Stats Section -->
        <div class="stats-grid mb-5">
            <div class="feature-item stat-item" *ngFor="let stat of statistics">
                <h3 class="stat-value">{{ stat.value }}</h3>
                <p class="stat-label">{{ stat.label }}</p>
            </div>
        </div>

        <div class="section-header">
            <h2 class="section-title">Key Features</h2>
            <div class="title-underline"></div>
        </div>

        <div class="icon-features-grid">
            <div class="feature-item" *ngFor="let feature of keyFeatures" style="padding: 2rem;">
                <div class="icon-box">
                    <mat-icon>{{ feature.icon }}</mat-icon>
                </div>
                <h4 class="feature-title">{{ feature.title }}</h4>
                <p class="feature-desc">{{ feature.description }}</p>
            </div>
        </div>
    </div>
</section>